<template>
    <teleport to="body">
        <div v-if="menu && menu.open" ref="menuEl" class="dropdown-menu show position-fixed" :style="menuStyle"
            @click.stop>
            <div v-if="menu.kind === 'tf'">
                <button v-for="t in timeframes" :key="t.key" type="button" class="dropdown-item"
                    @click="$emit('select-timeframe', t)">
                    {{ t.label }}
                </button>
            </div>
            <div v-else-if="menu.kind === 'type'">
                <button v-for="t in chartTypes" :key="t.key" type="button" class="dropdown-item"
                    @click="$emit('select-chart-type', t)">
                    {{ t.label }}
                </button>
                <div v-if="chartType && chartType.key === 'renko'" class="dropdown-divider"></div>
                <div v-if="chartType && chartType.key === 'renko'" class="px-3 pb-2">
                    <div class="small text-muted mb-1">Renko brick</div>
                    <input class="form-control form-control-sm mb-2" type="number" :value="renkoBrick" min="1" step="1"
                        @input="$emit('update:renkoBrick', Number($event.target.value))" />
                    <button class="btn btn-sm btn-primary w-100" type="button" @click="$emit('apply-chart-type')">
                        Apply
                    </button>
                </div>
            </div>
            <div v-else>
                <template v-if="currentStudies && currentStudies.length > 0">
                    <div class="px-3 pt-2 pb-1 text-primary small fw-bold">Current Studies</div>
                    <div class="px-3 pb-2">
                        <div v-for="s in currentStudies" :key="s.key"
                            class="d-flex align-items-center justify-content-between bg-light rounded px-2 py-1 mb-1">
                            <div class="small text-dark">{{ s.label }}</div>
                            <button type="button" class="btn btn-sm btn-link text-danger p-0"
                                @click="$emit('remove-study', s)">
                                ✕
                            </button>
                        </div>
                    </div>
                    <div class="px-3 pb-2">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            @click="$emit('clear-all-studies')">
                            Clear all
                        </button>
                    </div>
                    <div class="dropdown-divider"></div>
                </template>
                <ul class="nav nav-tabs px-3">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: modelTab === 'studies' }" href="#"
                            @click.prevent="modelTab = 'studies'">
                            Studies
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: modelTab === 'search' }" href="#"
                            @click.prevent="modelTab = 'search'">
                            Search
                        </a>
                    </li>
                </ul>
                <div class="px-3 pt-2">
                    <input :value="modelQ" class="form-control form-control-sm" placeholder="Search"
                        @input="modelQ = $event.target.value" />
                </div>
                <div class="mt-2">
                    <button v-for="item in filteredStudies" :key="item.key" type="button"
                        class="dropdown-item text-wrap" @click="$emit('add-study', item)">
                        {{ item.label }}
                    </button>
                </div>
            </div>
        </div>
    </teleport>
</template>
<script>
export default {
    name: "ChartDropdownMenu",
    props: {
        menu: { type: Object, required: true },
        timeframes: { type: Array, required: true },
        chartTypes: { type: Array, required: true },
        chartType: { type: Object, required: true },
        renkoBrick: { type: Number, default: 200 },
        currentStudies: { type: Array, default: () => [] },
        filteredStudies: { type: Array, default: () => [] },
        tab: { type: String, default: "studies" },
        q: { type: String, default: "" },
    },
    emits: [
        "select-timeframe",
        "select-chart-type",
        "apply-chart-type",
        "update:renkoBrick",
        "add-study",
        "remove-study",
        "clear-all-studies",
        "update:tab",
        "update:q",
        "menu-size",
    ],
    data() {
        return {
            ro: null,
            raf: 0,
        };
    },
    mounted() {
        this.setupObserver();
        this.emitSize();
    },
    updated() {
        this.emitSize();
        this.setupObserver();
    },
    beforeUnmount() {
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
    },
    methods: {
        setupObserver() {
            const el = this.$refs.menuEl;
            if (!el) return;
            if (this.ro) this.ro.disconnect();
            this.ro = new ResizeObserver(() => this.emitSize());
            this.ro.observe(el);
        },

        emitSize() {
            if (this.raf) cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => {
                const el = this.$refs.menuEl;
                if (!el) return;
                const { width, height } = el.getBoundingClientRect();
                this.$emit("menu-size", { width, height });
            });
        },
    },
    computed: {
        modelTab: {
            get() {
                return this.tab;
            },
            set(v) {
                this.$emit("update:tab", v);
            },
        },
        modelQ: {
            get() {
                return this.q;
            },
            set(v) {
                this.$emit("update:q", v);
            },
        },
        menuStyle() {
            return {
                left: (this.menu.left ?? 0) + "px",
                top: (this.menu.top ?? 0) + "px",
                maxHeight: this.menu.maxHeight ? this.menu.maxHeight + "px" : null,
                overflowY: "auto",
                overflowX: "hidden",
            };
        },
    },
};
</script>
